import { render, staticRenderFns } from "./PnvSelect.vue?vue&type=template&id=2c53a6ba&"
import script from "./PnvSelect.vue?vue&type=script&lang=ts&"
export * from "./PnvSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports